export default __webpack_public_path__ + "static/media/3.0dad9e76.gif";